export { AboutModalConfig } from './about-modal-config';
export { AboutModalComponent } from './about-modal.component';
export { AboutModalEvent } from './about-modal-event';
export { AboutModalModule } from './about-modal.module';
